import { createFileRoute } from "@tanstack/react-router";
import AdultChildWithDepression from "@/pages/AdultChildWithDepression";
export const Route = createFileRoute("/adult-child-with-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Adult Child With Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When your adult child struggles with depression, here’s how to help without taking over. Treatment options and warning signs in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Adult Child With Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When your adult child struggles with depression, here’s how to help without taking over. Treatment options and warning signs in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/adult-child-with-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/adult-child-with-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AdultChildWithDepression />;
}
